import { render } from "./termsPrivacy.vue?vue&type=template&id=6630f72f&scoped=true"
import script from "./termsPrivacy.vue?vue&type=script&lang=js"
export * from "./termsPrivacy.vue?vue&type=script&lang=js"

import "./termsPrivacy.vue?vue&type=style&index=0&id=6630f72f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6630f72f"]])

export default __exports__